export const industries = [
  {
    id: 'manufacturing',
    title: 'Manufacturing',
    summary: 'Gearbox and hydraulic repair support for manufacturing environments.',
    icon: '/icons/manufacturing.svg',
  },
  {
    id: 'material-handling',
    title: 'Material Handling',
    summary: 'Repair support for hydraulic and drive components used in handling and movement.',
    icon: '/icons/material-handling.svg',
  },
  {
    id: 'heavy-equipment',
    title: 'Construction',
    summary: 'Service pathways for hydraulic and mechanical repair needs.',
    icon: '/icons/construction.svg',
  },
  {
    id: 'agriculture',
    title: 'Agriculture',
    summary: 'Repair planning for hydraulic and gearbox equipment used in demanding environments.',
    icon: '/icons/agriculture.svg',
  },
  {
    id: 'energy',
    title: 'Energy',
    summary: 'Gearbox and hydraulic repair support for equipment and components.',
    icon: '/icons/energy.svg',
  },
];
